export default {
  stockCheck: {
    productBatch: 'Product Batch',
    originalQuantity: 'Original Quantity',
    checkQuantity: 'Check Quantity',
    checkFlag: 'Check Flag',
    productTime: 'Product Time',
    checkTime: 'Check Time',
    beforeCheckAmount: 'BeforeCheck Amount',
    afterCheckAmount: 'AfterCheck Amount',
    checkPerson: 'Check Person',
    viewRecord: 'View Record',
    checkAdd: 'Check Add'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/ims/stockCheck.js